/* PlansPricing.tsx generated by @compiled/babel-plugin v0.29.1 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';
import { FluidContainer, H4, NotFound, PartialOutageError, useAppPlans, useTeamSizeAndBillingFrequency } from '@atlassian/mpac-primitives';
import { ApolloErrorHandler, PlansEditionDetailsCard, PlansUserInputSection, PlansViewPricingLink } from '@atlassian/mpac-ui';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _24 = "._1yt4hiv4{padding:var(--ds-space-400)}";
const _23 = "._4t3i1osq{height:100%}";
const _22 = "._1bsb1osq{width:100%}";
const _21 = "._kqswstnw{position:absolute}";
const _20 = "@media not all and (min-width:64rem){._o5kc1y6m{justify-content:flex-start}}";
const _19 = "._1fjgglyw{scrollbar-width:none}";
const _18 = "._1reo1wug{overflow-x:auto}";
const _17 = "._1wpz1fhb{align-self:stretch}";
const _16 = "._zulphiv4{gap:var(--ds-space-400)}";
const _15 = "@media not all and (min-width:64rem){._159e1wug{align-self:auto}._2osnhiv4{gap:var(--ds-space-400)}}";
const _14 = "._1wpz1h6o{align-self:center}";
const _13 = "._p12f1ris{max-width:max-content}";
const _12 = "._zulpl6l0{gap:var(--ds-space-300)}";
const _11 = "@media not all and (min-width:64rem){._gu181e5h{text-align:left}}";
const _10 = "._y3gn1h6o{text-align:center}";
const _9 = "@media not all and (min-width:64rem){._3wvkidpf{margin-top:0}._1fbnidpf{margin-right:0}._1ubyidpf{margin-bottom:0}._1t0ridpf{margin-left:0}._tl28idpf{padding-top:0}._axwiidpf{padding-right:0}._1hwcidpf{padding-bottom:0}._sp8tidpf{padding-left:0}._2osnhiv4{gap:var(--ds-space-400)}}";
const _8 = "._ca0q1eps{padding-top:var(--ds-space-100)}";
const _7 = "._zulpa5zd{gap:var(--ds-space-600)}";
const _6 = "._2lx21bp4{flex-direction:column}";
const _5 = "._4t3i1kxc{height:100vh}";
const _4 = "._1bsbauwl{width:100vw}";
const _3 = "._4cvr1h6o{align-items:center}";
const _2 = "._1bah1h6o{justify-content:center}";
const _ = "._1e0c1txw{display:flex}";
const container = null;
const headingStyle = {
  textAlign: 'center',
  [media.below.md]: {
    textAlign: 'left'
  }
};
const plansPageBody = null;
const editionDetailsContainer = null;
const spinnerContainer = null;
const errorContainer = null;
export const PlansPricing = _ref => {
  var _error$extraInfo;
  let {
    appId
  } = _ref;
  const {
    data,
    loading,
    error
  } = useAppPlans({
    appId
  });
  const {
    teamSize,
    onTeamSizeChange,
    billingFrequency,
    onBillingFrequencyChange,
    lastTierCeiling
  } = useTeamSizeAndBillingFrequency({
    data
  });
  if (loading) {
    return /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2, _3, _4, _5]
      }), /*#__PURE__*/_jsx("div", {
        className: ax(["_1e0c1txw _1bah1h6o _4cvr1h6o _1bsbauwl _4t3i1kxc"]),
        children: /*#__PURE__*/_jsx(Spinner, {
          size: "large",
          testId: "plans-pricing-spinner"
        })
      })]
    });
  }
  if (data) {
    var _data$editions;
    return /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _6, _7, _8, _9]
      }), /*#__PURE__*/_jsxs(FluidContainer, {
        className: ax(["_1e0c1txw _2lx21bp4 _zulpa5zd _ca0q1eps _3wvkidpf _1fbnidpf _1ubyidpf _1t0ridpf _tl28idpf _axwiidpf _1hwcidpf _sp8tidpf _2osnhiv4"]),
        children: [/*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_10, _11]
          }), /*#__PURE__*/_jsx(H4, {
            as: "h2",
            className: ax(["_y3gn1h6o _gu181e5h"]),
            children: "Simple, transparent pricing for your team"
          })]
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_, _6, _3, _12, _13, _14, _15]
          }), /*#__PURE__*/_jsxs("div", {
            className: ax(["_1e0c1txw _2lx21bp4 _4cvr1h6o _zulpl6l0 _p12f1ris _1wpz1h6o _159e1wug _2osnhiv4"]),
            children: [/*#__PURE__*/_jsx(PlansUserInputSection, {
              teamSize: teamSize,
              onTeamSizeChange: onTeamSizeChange,
              onBillingFrequencyChange: onBillingFrequencyChange,
              billingFrequency: billingFrequency
            }), /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_, _2, _16, _17, _18, _19, _20]
              }), /*#__PURE__*/_jsx("div", {
                "data-testid": "plans-edition-details-cards",
                className: ax(["_1e0c1txw _1bah1h6o _zulphiv4 _1wpz1fhb _1reo1wug _1fjgglyw _o5kc1y6m"]),
                children: (_data$editions = data.editions) === null || _data$editions === void 0 ? void 0 : _data$editions.map(item => /*#__PURE__*/_jsx(PlansEditionDetailsCard, {
                  editionDetails: item,
                  billingFrequency: billingFrequency,
                  teamSize: teamSize,
                  lastTierCeiling: lastTierCeiling,
                  source: "pricingTab"
                }, item.type))
              })]
            }), /*#__PURE__*/_jsx(PlansViewPricingLink, {
              editions: data.editions,
              billingFrequency: billingFrequency
            })]
          })]
        })]
      })]
    });
  }
  if (error && ((_error$extraInfo = error.extraInfo) === null || _error$extraInfo === void 0 ? void 0 : _error$extraInfo.code) !== 'NOT_FOUND') {
    return /*#__PURE__*/_jsx(ApolloErrorHandler, {
      error: error,
      context: {
        page: 'AppPlansPage',
        operationName: 'GetAppDetailsWithEditions'
      },
      renderError: () => /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_21, _22, _23, _24]
        }), /*#__PURE__*/_jsx("div", {
          className: ax(["_kqswstnw _1bsb1osq _4t3i1osq _1yt4hiv4"]),
          children: /*#__PURE__*/_jsx(PartialOutageError, {
            level: "global"
          })
        })]
      })
    });
  }
  return /*#__PURE__*/_jsx(NotFound, {});
};